/*
 * @Author: tianshuai 1446360207@qq.com
 * @Date: 2024-09-12 10:42:42
 * @LastEditors: tianshuai 1446360207@qq.com
 * @LastEditTime: 2024-10-16 15:16:15
 * @FilePath: \惠宾官网\src\utils\rem.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// // rem等比适配配置文件
// // 基准大小
const baseSize = 10
// 设置 rem 函数
function setRem () {
  // 当前页面屏幕分辨率相对于 1920宽的缩放比例，可根据自己需要修改
  const scale = document.documentElement.clientWidth / window.innerWidth
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
  let fontSize=baseSize * Math.min(scale, 1);
  
  console.log("fontSize:",fontSize);
  
  document.documentElement.style.fontSize = fontSize + 'px';
}
// 根节点字体大小
function fontSize() {
  var size;
  var winW = $(window).width();
  // console.log(0,winW);
  
  if (winW <= 1640 && winW > 800) {
      size = Math.round(winW / 164)-1;
      console.log("800~1640",size);
  } else if (winW <= 800) {
      size = Math.round(winW / 7.5);
      if (size > 6.5) {
          size = 6;
          console.log("<= 800:",size);
      }
  }else if(winW>3400){
    size = 26;
    console.log(">3400",size);
  } else if(winW>3200){
    size = 24;
    console.log(">3200",size);
  }else if(winW>3000){
    size = 22;
    console.log(">3000",size);
  }else if(winW>2800){
    size = 20;
    console.log(">2800",size);
  }else if(winW>2600){
    size = 18;
    console.log(">2600",size);
  }else if(winW>2400){
    size = 16;
    console.log(">2400",size);
  }else if(winW>2200){
    size = 14;
    console.log(">2200",size);
  }else if(winW>2000){
    size = 12;
    console.log(">2000",size);
  }else {
    size = 10;
    // console.log("333:",size);
  }
  
  
  $('html').css({
      'font-size': size + 'px'
  })
}
// 初始化
// setRem();
fontSize();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  // setRem()
  fontSize();
}